import * as chains from 'viem/chains';
import ALGO from '../assets/images/chains/algorand-logo.svg';
import AVAX from '../assets/images/chains/avalanche-avax-logo.svg';
import BSC from '../assets/images/chains/bnb-bnb-logo.svg';
import ARB from '../assets/images/chains/arbitrum-arb-logo.png';
import OPT from '../assets/images/chains/optimism-ethereum-op-logo.svg';
import MAT from '../assets/images/chains/Polygon.svg';
import BASE from '../assets/images/chains/base.png';
import PERA from '../assets/images/wallets/Pera.svg';
import WALL_CONN from '../assets/images/wallets/WalletConnect.svg';
import ETHEREUM from '../assets/images/chains/ethereum-logo.svg'
import { getChains } from '../services/localStorage.service';
import SOLANA from '../assets/images/chains/solana-light.svg';
import BACKPACK from '../assets/images/wallets/backpack.png';
import PHA from '../assets/images/wallets/Phantom_Icon.svg';
import SOL from '../assets/images/wallets/solflare.png';
import COINBASE from '../assets/images/wallets/coinbase.png';
import CIRCLE from '../assets/images/chains/circle.png';
import { IEvmChainInfo } from '@libs/shared/services/tmc.service';
import { TMCManager } from '@libs/shared/services/tmc.service';
import { Chain } from '../redux/_reducers/wallet.reducer';
import { ALGO_NETWORK } from '../constants/constants';
import { isAddress } from 'viem';
import algosdk from 'algosdk';
import { PublicKey } from '@solana/web3.js';

const isMainnet = ALGO_NETWORK === 'MainNet';

const getTmcManager = (initChains?: any[]) => new TMCManager(initChains || getChains()) as TMCManager;

export const getAvaibleWhChainIds = (initChains?: any[]) => getTmcManager(initChains).getAvailableWhChains();

export const getAvailableWhChainsInfo = () => [...getTmcManager().getTmcContracts()].map(el => el[1]);

export const getTmcByEvmChainId = (chainId: number) =>
  getTmcManager().getTmcByEvmChainId(chainId);

export const getTmcByWhChain = (chain: BLOCKCHAINS) =>
  getTmcManager().getTMC(getWhChainId(chain));

export const getChainsConfig = (initChains?: any[]) => {
  const CHAIN_CONFIGS: Map<number, chains.Chain> = new Map(
    Object.values(chains).reduce((configs, chain) => {
      configs.push([chain.id, chain]);
      return configs;
    }, [])
  );
  return CHAIN_CONFIGS;
}

export const getLoginChainId = (loginChain: string) => {
  const chainId = WH_PROVIDER_CHAIN_ID[loginChain];
  if (chainId === 8 || chainId === 1) {
    return chainId;
  }
  return 5;
}

export const CHAIN_CONFIGS: Map<number, chains.Chain> = new Map(
  Object.values(chains).reduce((configs, chain) => {
    configs.push([chain.id, chain]);
    return configs;
  }, [])
);

/**
 * Enum representing different blockchains.
 * Use this enum as a base to maintain the structure with keys throughout the codebase.
 * Additional enums can be created to extend its functionality while keeping the structure the same.
 */
export enum BLOCKCHAINS {
  "ALGORAND" = 'Algorand',
  // ARBITRUM = 'Arbitrum One',
  // ETHEREUM = 'Ethereum Goerli',
  // ETHEREUM_SEPOLIA = 'Ethereum Sepolia',
  // OPTIMISM = 'Optimism Testnet',
  // BASE = 'Base Testnet',
  // OPTIMISM_SEPOLIA = 'Optimism Sepolia',

  "SOLANA" = 'Solana',

  "5IRECHAIN_THUNDER_TESTNET"= "5ireChain Thunder Testnet",
  "ACALA"= "Acala",
  "ALFAJORES"= "Alfajores",
  "APOTHEM_NETWORK"= "Apothem Network",
  "ARBITRUM_GOERLI"= "Arbitrum Goerli",
  "ARBITRUM_NOVA"= "Arbitrum Nova",
  "ARBITRUM_ONE"= "Arbitrum",
  "ARBITRUM_SEPOLIA"= "Arbitrum Sepolia",
  "ASTAR"= "Astar",
  "ASTAR_ZKEVM_TESTNET_ZKATANA"= "Astar zkEVM Testnet zKatana",
  "AURORA"= "Aurora",
  "AURORA_TESTNET"= "Aurora Testnet",
  "AVALANCHE"= "Avalanche",
  "AVALANCHE_FUJI"= "Avalanche Fuji",
  "BAHAMUT"= "Bahamut",
  "BASE"= "Base",
  "BASE_GOERLI"= "Base Goerli",
  "BASE_SEPOLIA"= "Base Sepolia",
  "BEAR_NETWORK_CHAIN_MAINNET"= "Bear Network Chain Mainnet",
  "BEAR_NETWORK_CHAIN_TESTNET"= "Bear Network Chain Testnet",
  "BERACHAIN_ARTIO"= "Berachain Artio",
  "BERESHEET_BEREEVM_TESTNET"= "Beresheet BereEVM Testnet",
  "BINANCE_SMART_CHAIN_TESTNET"= "BNB Chain Testnet",
  "BITTORRENT"= "BitTorrent",
  "BITTORRENT_CHAIN_TESTNET"= "BitTorrent Chain Testnet",
  "BLACKFORT_EXCHANGE_NETWORK"= "BlackFort Exchange Network",
  "BLACKFORT_EXCHANGE_NETWORK_TESTNET"= "BlackFort Exchange Network Testnet",
  "BLAST_SEPOLIA"= "Blast Sepolia",
  "BNB_SMART_CHAIN"= "BNB Chain",
  "BOBA_NETWORK"= "Boba Network",
  "BRONOS"= "Bronos",
  "BRONOS_TESTNET"= "Bronos Testnet",
  "CANTO"= "Canto",
  "CELO"= "Celo",
  "CHILIZ_CHAIN"= "Chiliz Chain",
  "CHILIZ_SPICY_TESTNET"= "Chiliz Spicy Testnet",
  "CONFLUX_ESPACE"= "Conflux eSpace",
  "CONFLUX_ESPACE_TESTNET"= "Conflux eSpace Testnet",
  "CORE_DAO"= "Core Dao",
  "COSTON"= "Coston",
  "COSTON2"= "Coston2",
  "CRONOS_MAINNET"= "Cronos Mainnet",
  "CRONOS_TESTNET"= "Cronos Testnet",
  "CROSSBELL"= "Crossbell",
  "DEFICHAIN_EVM_MAINNET"= "DeFiChain EVM Mainnet",
  "DEFICHAIN_EVM_TESTNET"= "DeFiChain EVM Testnet",
  "DFK_CHAIN"= "DFK Chain",
  "DOGECHAIN"= "Dogechain",
  "EDGEWARE_EDGEEVM_MAINNET"= "Edgeware EdgeEVM Mainnet",
  "EKTA"= "Ekta",
  "EKTA_TESTNET"= "Ekta Testnet",
  "EOS_EVM"= "EOS EVM",
  "EOS_EVM_TESTNET"= "EOS EVM Testnet",
  "ETHEREUM"= "Ethereum",
  "ETHEREUM_CLASSIC"= "Ethereum Classic",
  "EVMOS"= "Evmos",
  "EVMOS_TESTNET"= "Evmos Testnet",
  "FANTOM"= "Fantom",
  "FANTOM_SONIC_OPEN_TESTNET"= "Fantom Sonic Open Testnet",
  "FANTOM_TESTNET"= "Fantom Testnet",
  "FIBO_CHAIN"= "Fibo Chain",
  "FILECOIN_CALIBRATION"= "Filecoin Calibration",
  "FILECOIN_HYPERSPACE"= "Filecoin Hyperspace",
  "FILECOIN_MAINNET"= "Filecoin Mainnet",
  "FLARE_MAINNET"= "Flare Mainnet",
  "FOUNDRY"= "Foundry",
  "FUSE"= "Fuse",
  "FUSE_SPARKNET"= "Fuse Sparknet",
  "GNOSIS"= "Gnosis",
  "GNOSIS_CHIADO"= "Gnosis Chiado",
  "GOERLI"= "Goerli",
  "HAQQ_MAINNET"= "HAQQ Mainnet",
  "HAQQ_TESTEDGE_2"= "HAQQ Testedge 2",
  "HARDHAT"= "Hardhat",
  "HARMONY_ONE"= "Harmony One",
  "HEDERA_MAINNET"= "Hedera Mainnet",
  "HEDERA_PREVIEWNET"= "Hedera Previewnet",
  "HEDERA_TESTNET"= "Hedera Testnet",
  "HOLESKY"= "Holesky",
  "HORIZEN_GOBI_TESTNET"= "Horizen Gobi Testnet",
  "IOTEX"= "IoTeX",
  "IOTEX_TESTNET"= "IoTeX Testnet",
  "JIBCHAIN_L1"= "JIBCHAIN L1",
  "KARURA"= "Karura",
  "KAVA_EVM"= "Kava EVM",
  "KAVA_EVM_TESTNET"= "Kava EVM Testnet",
  "KCC_MAINNET"= "KCC Mainnet",
  "KLAYTN"= "Klaytn",
  "KLAYTN_BAOBAB_TESTNET"= "Klaytn Baobab Testnet",
  "KROMA"= "Kroma",
  "KROMA_SEPOLIA"= "Kroma Sepolia",
  "LIGHTLINK_PEGASUS_TESTNET"= "LightLink Pegasus Testnet",
  "LIGHTLINK_PHOENIX"= "LightLink Phoenix",
  "LINEA_GOERLI_TESTNET"= "Linea Goerli Testnet",
  "LINEA_MAINNET"= "Linea Mainnet",
  "LOCALHOST"= "Localhost",
  "LUKSO"= "LUKSO",
  "MANDALA_TC9"= "Mandala TC9",
  "MANTA_PACIFIC_MAINNET"= "Manta Pacific Mainnet",
  "MANTA_PACIFIC_TESTNET"= "Manta Pacific Testnet",
  "MANTLE"= "Mantle",
  "MANTLE_TESTNET"= "Mantle Testnet",
  "METACHAIN_MAINNET"= "MetaChain Mainnet",
  "METER"= "Meter",
  "METER_TESTNET"= "Meter Testnet",
  "METIS"= "Metis",
  "METIS_GOERLI"= "Metis Goerli",
  "MEVERSE_CHAIN_MAINNET"= "MEVerse Chain Mainnet",
  "MEVERSE_CHAIN_TESTNET"= "MEVerse Chain Testnet",
  "MODE_TESTNET"= "Mode Testnet",
  "MOONBASE_ALPHA"= "Moonbase Alpha",
  "MOONBEAM"= "Moonbeam",
  "MOONBEAM_DEVELOPMENT_NODE"= "Moonbeam Development Node",
  "MOONRIVER"= "Moonriver",
  "NEON_EVM_DEVNET"= "Neon EVM DevNet",
  "NEON_EVM_MAINNET"= "Neon EVM MainNet",
  "NEXI"= "Nexi",
  "NEXILIX_SMART_CHAIN"= "Nexilix Smart Chain",
  "OASIS_SAPPHIRE"= "Oasis Sapphire",
  "OASIS_SAPPHIRE_TESTNET"= "Oasis Sapphire Testnet",
  "OASIS_TESTNET"= "Oasis Testnet",
  "OASYS"= "Oasys",
  "OKC"= "OKC",
  "OORT_MAINNETDEV"= "OORT MainnetDev",
  "OPBNB"= "opBNB",
  "OPBNB_TESTNET"= "opBNB Testnet",
  "OPTIMISM_GOERLI"= "Optimism Goerli",
  "OP_MAINNET"= "Optimism",
  "OP_SEPOLIA"= "Optimism Sepolia",
  "PALM"= "Palm",
  "PALM_TESTNET"= "Palm Testnet",
  "PGN"= "PGN",
  "PGN_"= "PGN ",
  "PLINGA"= "Plinga",
  "POLYGON"= "Polygon",
  "POLYGON_AMOY"= "Polygon Amoy",
  "POLYGON_MUMBAI"= "Polygon Mumbai",
  "POLYGON_ZKEVM"= "Polygon zkEVM",
  "POLYGON_ZKEVM_TESTNET"= "Polygon zkEVM Testnet",
  "PULSECHAIN"= "PulseChain",
  "PULSECHAIN_V4"= "PulseChain V4",
  "Q_MAINNET"= "Q Mainnet",
  "Q_TESTNET"= "Q Testnet",
  "ROLLUX_MAINNET"= "Rollux Mainnet",
  "ROLLUX_TESTNET"= "Rollux Testnet",
  "RONIN"= "Ronin",
  "ROOTSTOCK_MAINNET"= "Rootstock Mainnet",
  "SAIGON_TESTNET"= "Saigon Testnet",
  "SCROLL"= "Scroll",
  "SCROLL_SEPOLIA"= "Scroll Sepolia",
  "SCROLL_TESTNET"= "Scroll Testnet",
  "SEPOLIA"= "Ethereum Sepolia",
  "SHARDEUM_SPHINX"= "Shardeum Sphinx",
  "SHIBARIUM"= "Shibarium",
  "SHIMMER"= "Shimmer",
  "SHIMMER_TESTNET"= "Shimmer Testnet",
  "SKALE_|_BLOCK_BRAWLERS"= "SKALE | Block Brawlers",
  "SKALE_|_CALYPSO_NFT_HUB"= "SKALE | Calypso NFT Hub",
  "SKALE_|_CALYPSO_NFT_HUB_TESTNET"= "SKALE | Calypso NFT Hub Testnet",
  "SKALE_|_CHAOS_TESTNET"= "SKALE | Chaos Testnet",
  "SKALE_|_CRYPTOBLADES"= "SKALE | CryptoBlades",
  "SKALE_|_CRYPTO_COLOSSEUM"= "SKALE | Crypto Colosseum",
  "SKALE_|_EUROPA_LIQUIDITY_HUB"= "SKALE | Europa Liquidity Hub",
  "SKALE_|_EUROPA_LIQUIDITY_HUB_TESTNET"= "SKALE | Europa Liquidity Hub Testnet",
  "SKALE_|_EXORDE"= "SKALE | Exorde",
  "SKALE_|_HUMAN_PROTOCOL"= "SKALE | Human Protocol",
  "SKALE_|_NEBULA_GAMING_HUB"= "SKALE | Nebula Gaming Hub",
  "SKALE_|_NEBULA_GAMING_HUB_TESTNET"= "SKALE | Nebula Gaming Hub Testnet",
  "SKALE_|_RAZOR_NETWORK"= "SKALE | Razor Network",
  "SKALE_|_TITAN_COMMUNITY_HUB"= "SKALE | Titan Community Hub",
  "SKALE_|_TITAN_COMMUNITY_HUB_TESTNET"= "SKALE | Titan Community Hub Testnet",
  "SONGBIRD_MAINNET"= "Songbird Mainnet",
  "SYSCOIN_MAINNET"= "Syscoin Mainnet",
  "SYSCOIN_TANENBAUM_TESTNET"= "Syscoin Tanenbaum Testnet",
  "TAIKO_(ALPHA-3_TESTNET)"= "Taiko (Alpha-3 Testnet)",
  "TAIKO_JOLNIR_(ALPHA-5_TESTNET)"= "Taiko Jolnir (Alpha-5 Testnet)",
  "TAIKO_KATLA_(ALPHA-6_TESTNET)"= "Taiko Katla (Alpha-6 Testnet)",
  "TARAXA_MAINNET"= "Taraxa Mainnet",
  "TARAXA_TESTNET"= "Taraxa Testnet",
  "TELOS"= "Telos",
  "TENET"= "Tenet",
  "VECHAIN"= "Vechain",
  "WANCHAIN"= "Wanchain",
  "WANCHAIN_TESTNET"= "Wanchain Testnet",
  "WEMIX"= "WEMIX",
  "WEMIX_TESTNET"= "WEMIX Testnet",
  "X1_TESTNET"= "X1 Testnet",
  "XINFIN_NETWORK"= "XinFin Network",
  "ZETACHAIN_ATHENS_TESTNET"= "ZetaChain Athens Testnet",
  "ZHEJIANG"= "Zhejiang",
  "ZILLIQA"= "Zilliqa",
  "ZILLIQA_TESTNET"= "Zilliqa Testnet",
  "ZKFAIR_MAINNET"= "ZKFair Mainnet",
  "ZKFAIR_TESTNET"= "ZKFair Testnet",
  "ZKSYNC_ERA"= "zkSync Era",
  "ZKSYNC_ERA_TESTNET"= "zkSync Era Testnet",
  "ZKSYNC_SEPOLIA_TESTNET"= "zkSync Sepolia Testnet",
  "ZORA"= "Zora",
  "ZORA_GOERLI_TESTNET"= "Zora Goerli Testnet",
  "ZORA_SEPOLIA"= "Zora Sepolia",
}

export const EVM_IDS_BLOCKCHAINS = {
  "5ireChain Thunder Testnet": 997,
  Acala: 787,
  Alfajores: 44787,
  "Apothem Network": 51,
  "Arbitrum Goerli": 421613,
  "Arbitrum Nova": 42170,
  "Arbitrum": 42161,
  "Arbitrum Sepolia": 421614,
  Astar: 592,
  "Astar zkEVM Testnet zKatana": 1261120,
  Aurora: 1313161554,
  "Aurora Testnet": 1313161555,
  Avalanche: 43114,
  "Avalanche Fuji": 43113,
  "BNB Chain": 56,
  Bahamut: 5165,
  Base: 8453,
  "Base Goerli": 84531,
  "Base Sepolia": 84532,
  "Bear Network Chain Mainnet": 641230,
  "Bear Network Chain Testnet": 751230,
  "Berachain Artio": 80085,
  "Beresheet BereEVM Testnet": 2022,
  "BNB Chain Testnet": 97,
  BitTorrent: 199,
  "BitTorrent Chain Testnet": 1028,
  "BlackFort Exchange Network": 4999,
  "BlackFort Exchange Network Testnet": 4777,
  "Blast Sepolia": 168587773,
  "Boba Network": 288,
  Bronos: 1039,
  "Bronos Testnet": 1038,
  Canto: 7700,
  Celo: 42220,
  "Chiliz Chain": 88888,
  "Chiliz Spicy Testnet": 88882,
  "Conflux eSpace": 1030,
  "Conflux eSpace Testnet": 71,
  "Core Dao": 1116,
  Coston: 16,
  Coston2: 114,
  "Cronos Mainnet": 25,
  "Cronos Testnet": 338,
  Crossbell: 3737,
  "DFK Chain": 53935,
  "DeFiChain EVM Mainnet": 1130,
  "DeFiChain EVM Testnet": 1131,
  Dogechain: 2000,
  "EOS EVM": 17777,
  "EOS EVM Testnet": 15557,
  "Edgeware EdgeEVM Mainnet": 2021,
  Ekta: 1994,
  "Ekta Testnet": 1004,
  Ethereum: 1,
  "Ethereum Classic": 61,
  Evmos: 9001,
  "Evmos Testnet": 9000,
  Fantom: 250,
  "Fantom Sonic Open Testnet": 64240,
  "Fantom Testnet": 4002,
  "Fibo Chain": 12306,
  "Filecoin Calibration": 314159,
  "Filecoin Hyperspace": 3141,
  "Filecoin Mainnet": 314,
  "Flare Mainnet": 14,
  Foundry: 31337,
  Fuse: 122,
  "Fuse Sparknet": 123,
  Gnosis: 100,
  "Gnosis Chiado": 10200,
  Goerli: 5,
  "HAQQ Mainnet": 11235,
  "HAQQ Testedge 2": 54211,
  Hardhat: 31337,
  "Harmony One": 1666600000,
  "Hedera Mainnet": 295,
  "Hedera Previewnet": 297,
  "Hedera Testnet": 296,
  Holesky: 17000,
  "Horizen Gobi Testnet": 1663,
  IoTeX: 4689,
  "IoTeX Testnet": 4690,
  "JIBCHAIN L1": 8899,
  "KCC Mainnet": 321,
  Karura: 686,
  "Kava EVM": 2222,
  "Kava EVM Testnet": 2221,
  Klaytn: 8217,
  "Klaytn Baobab Testnet": 1001,
  Kroma: 255,
  "Kroma Sepolia": 2358,
  LUKSO: 42,
  "LightLink Pegasus Testnet": 1891,
  "LightLink Phoenix": 1890,
  "Linea Goerli Testnet": 59140,
  "Linea Mainnet": 59144,
  Localhost: 1337,
  "MEVerse Chain Mainnet": 7518,
  "MEVerse Chain Testnet": 4759,
  "Mandala TC9": 595,
  "Manta Pacific Mainnet": 169,
  "Manta Pacific Testnet": 3441005,
  Mantle: 5000,
  "Mantle Testnet": 5001,
  "MetaChain Mainnet": 571,
  Meter: 82,
  "Meter Testnet": 83,
  Metis: 1088,
  "Metis Goerli": 599,
  "Mode Testnet": 919,
  "Moonbase Alpha": 1287,
  Moonbeam: 1284,
  "Moonbeam Development Node": 1281,
  Moonriver: 1285,
  "Neon EVM DevNet": 245022926,
  "Neon EVM MainNet": 245022934,
  Nexi: 4242,
  "Nexilix Smart Chain": 240,
  OKC: 66,
  "OORT MainnetDev": 9700,
  "Optimism": 10,
  "Optimism Sepolia": 11155420,
  "Oasis Sapphire": 23294,
  "Oasis Sapphire Testnet": 23295,
  "Oasis Testnet": 4090,
  Oasys: 248,
  "Optimism Goerli": 420,
  PGN: 424,
  "PGN ": 58008,
  Palm: 11297108109,
  "Palm Testnet": 11297108099,
  Plinga: 242,
  Polygon: 137,
  "Polygon Amoy": 80002,
  "Polygon Mumbai": 80001,
  "Polygon zkEVM": 1101,
  "Polygon zkEVM Testnet": 1442,
  PulseChain: 369,
  "PulseChain V4": 943,
  "Q Mainnet": 35441,
  "Q Testnet": 35443,
  "Rollux Mainnet": 570,
  "Rollux Testnet": 57000,
  Ronin: 2020,
  "Rootstock Mainnet": 30,
  "SKALE | Block Brawlers": 391845894,
  "SKALE | Calypso NFT Hub": 1564830818,
  "SKALE | Calypso NFT Hub Testnet": 344106930,
  "SKALE | Chaos Testnet": 1351057110,
  "SKALE | Crypto Colosseum": 2046399126,
  "SKALE | CryptoBlades": 1026062157,
  "SKALE | Europa Liquidity Hub": 2046399126,
  "SKALE | Europa Liquidity Hub Testnet": 476158412,
  "SKALE | Exorde": 2139927552,
  "SKALE | Human Protocol": 1273227453,
  "SKALE | Nebula Gaming Hub": 1482601649,
  "SKALE | Nebula Gaming Hub Testnet": 503129905,
  "SKALE | Razor Network": 278611351,
  "SKALE | Titan Community Hub": 1350216234,
  "SKALE | Titan Community Hub Testnet": 1517929550,
  "Saigon Testnet": 2021,
  Scroll: 534352,
  "Scroll Sepolia": 534351,
  "Scroll Testnet": 534353,
  "Ethereum Sepolia": 11155111,
  "Shardeum Sphinx": 8082,
  Shibarium: 109,
  Shimmer: 148,
  "Shimmer Testnet": 1073,
  "Songbird Mainnet": 19,
  "Syscoin Mainnet": 57,
  "Syscoin Tanenbaum Testnet": 5700,
  "Taiko (Alpha-3 Testnet)": 167005,
  "Taiko Jolnir (Alpha-5 Testnet)": 167007,
  "Taiko Katla (Alpha-6 Testnet)": 167008,
  "Taraxa Mainnet": 841,
  "Taraxa Testnet": 842,
  Telos: 41,
  Tenet: 1559,
  Vechain: 100009,
  WEMIX: 1111,
  "WEMIX Testnet": 1112,
  Wanchain: 888,
  "Wanchain Testnet": 999,
  "X1 Testnet": 195,
  "XinFin Network": 50,
  "ZKFair Mainnet": 42766,
  "ZKFair Testnet": 43851,
  "ZetaChain Athens Testnet": 7001,
  Zhejiang: 1337803,
  Zilliqa: 32769,
  "Zilliqa Testnet": 33101,
  Zora: 7777777,
  "Zora Goerli Testnet": 999,
  "Zora Sepolia": 999999999,
  opBNB: 204,
  "opBNB Testnet": 5611,
  "zkSync Era": 324,
  "zkSync Era Testnet": 280,
  "zkSync Sepolia Testnet": 300,
} as const;

const WH_PROVIDER_CHAIN_ID_TESTNET = {
  [BLOCKCHAINS.SOLANA]: 1,
  [BLOCKCHAINS.ALGORAND]: 8,
  [BLOCKCHAINS.POLYGON_MUMBAI]: 5,
  [BLOCKCHAINS.BINANCE_SMART_CHAIN_TESTNET]: 4,
  [BLOCKCHAINS.AVALANCHE_FUJI]: 6,
  [BLOCKCHAINS.ARBITRUM_ONE]: 23,
  [BLOCKCHAINS.ARBITRUM_GOERLI]: 23,
  [BLOCKCHAINS.ARBITRUM_SEPOLIA]: 10003,
  [BLOCKCHAINS.OPTIMISM_GOERLI]: 24,
  [BLOCKCHAINS.OP_SEPOLIA]: 10005,
  [BLOCKCHAINS.BASE_GOERLI]: 30,
  [BLOCKCHAINS.ETHEREUM]: 2,
  [BLOCKCHAINS.SEPOLIA]: 10002,
  [BLOCKCHAINS.BASE_SEPOLIA]: 10004,
  [BLOCKCHAINS.POLYGON_AMOY]: 10007,

}

const WH_PROVIDER_CHAIN_ID_MAINNET = {
  [BLOCKCHAINS.ALGORAND]: 8,
  [BLOCKCHAINS.AVALANCHE]: 6,
  [BLOCKCHAINS.ARBITRUM_ONE]: 23,
  [BLOCKCHAINS.OP_MAINNET]: 24,
  [BLOCKCHAINS.BASE]: 30,
  [BLOCKCHAINS.ETHEREUM]: 2,
  [BLOCKCHAINS.SOLANA]: 1,
  [BLOCKCHAINS.POLYGON]: 5,
  [BLOCKCHAINS.BNB_SMART_CHAIN]: 4,
  // [BLOCKCHAINS.ARBITRUM_SEPOLIA]: 10003,
  // [BLOCKCHAINS.OP_SEPOLIA]: 10005,
  // [BLOCKCHAINS.SEPOLIA]: 10002,
  // [BLOCKCHAINS.BASE_SEPOLIA]: 10004,
  // [BLOCKCHAINS.POLYGON_AMOY]: 10007,

}

export enum MAIN_BLOCKCHAINS {
  ALGORAND = 'Algorand',
  SOLANA = 'Solana',
  EVM = 'EVM',
}

export const WH_MAIN_CHAIN_ID = {
  [MAIN_BLOCKCHAINS.ALGORAND]: 8,
  [MAIN_BLOCKCHAINS.EVM]: 5,
  [MAIN_BLOCKCHAINS.SOLANA]: 1,
}

export const getMainChainNameByWHID = (id: number | string): MAIN_BLOCKCHAINS | undefined => {
  return Object.entries(WH_MAIN_CHAIN_ID).find(([_, val]) => val === Number(id))?.[0] as MAIN_BLOCKCHAINS | undefined;
};

export const getMainChains = () => Object.entries(WH_MAIN_CHAIN_ID);

export const WH_PROVIDER_CHAIN_ID = isMainnet ? WH_PROVIDER_CHAIN_ID_MAINNET : WH_PROVIDER_CHAIN_ID_TESTNET as Record<BLOCKCHAINS, number>;

export const WH_PROVIDER_CHAIN_NAME = Object.entries(WH_PROVIDER_CHAIN_ID).reduce((acc, [key, value]) => {
  acc[value] = key as BLOCKCHAINS;
  return acc;
}, {} as Record<number, BLOCKCHAINS>);

/** BASE END */

// TODO: add provider images
export function getProviderImage(provider: string) {}

export const CHAIN_LOGO = {
  [BLOCKCHAINS.ALGORAND]: ALGO,
  [BLOCKCHAINS.POLYGON_MUMBAI]: MAT,
  [BLOCKCHAINS.BINANCE_SMART_CHAIN_TESTNET]: BSC,
  [BLOCKCHAINS.BNB_SMART_CHAIN]: BSC,
  [BLOCKCHAINS.AVALANCHE_FUJI]: AVAX,
  [BLOCKCHAINS.AVALANCHE]: AVAX,
  [BLOCKCHAINS.ARBITRUM_ONE]: ARB,
  // [BLOCKCHAINS.OPTIMISM]: OPT,
  [BLOCKCHAINS.BASE_GOERLI]: BASE,
  [BLOCKCHAINS.SEPOLIA]: ETHEREUM,
  [BLOCKCHAINS.BASE_SEPOLIA]: BASE,
  [BLOCKCHAINS.ETHEREUM]: ETHEREUM,
  [BLOCKCHAINS.SOLANA]: SOLANA,
  [BLOCKCHAINS.ARBITRUM_GOERLI]: ARB,
  [BLOCKCHAINS.ARBITRUM_SEPOLIA]: ARB,
  [BLOCKCHAINS.OPTIMISM_GOERLI]: OPT,
  [BLOCKCHAINS.OP_SEPOLIA]: OPT,
  [BLOCKCHAINS.POLYGON]: MAT,
  [BLOCKCHAINS.OP_MAINNET]: OPT,
  [BLOCKCHAINS.BASE]: BASE,
  [BLOCKCHAINS.POLYGON_AMOY]: MAT,
  65537: CIRCLE,

};

export const BLOCKCHAIN_EXPLORER = {
  [BLOCKCHAINS.ALGORAND] : isMainnet ? "https://explorer.perawallet.app" : "https://testnet.explorer.perawallet.app",
  [BLOCKCHAINS.POLYGON_MUMBAI] : "https://mumbai.polygonscan.com",
  [BLOCKCHAINS.BINANCE_SMART_CHAIN_TESTNET]: "https://testnet.bscscan.com",
  [BLOCKCHAINS.BNB_SMART_CHAIN]: "https://bscscan.com",
  [BLOCKCHAINS.AVALANCHE_FUJI]: "https://testnet.avascan.info/blockchain/c/",
  [BLOCKCHAINS.ARBITRUM_ONE]: "https://arbiscan.io",
  [BLOCKCHAINS.OP_MAINNET]: "https://optimistic.etherscan.io",
  [BLOCKCHAINS.AVALANCHE]: "https://avascan.info/blockchain/c/",
  // [BLOCKCHAINS.OPTIMISM]: "https://optimistic.etherscan.io",
  [BLOCKCHAINS.BASE_GOERLI]: "https://basescan.org",
  [BLOCKCHAINS.BASE_SEPOLIA]: "https://base-sepolia.blockscout.com",
  [BLOCKCHAINS.BASE]: "https://base.blockscout.com",
  [BLOCKCHAINS.SEPOLIA]: "https://sepolia.etherscan.io",
  [BLOCKCHAINS.ETHEREUM]: "https://etherscan.io",
  [BLOCKCHAINS.SOLANA]: "https://explorer.solana.com",
  [BLOCKCHAINS.ARBITRUM_GOERLI]: "https://arbiscan.io",
  [BLOCKCHAINS.ARBITRUM_SEPOLIA]: "https://sepolia.arbiscan.io",
  [BLOCKCHAINS.OPTIMISM_GOERLI]: "https://optimistic.etherscan.io",
  [BLOCKCHAINS.OP_SEPOLIA]: "https://sepolia-optimistic.etherscan.io",
  [BLOCKCHAINS.POLYGON_AMOY]: "https://amoy.polygonscan.com",
  [BLOCKCHAINS.POLYGON]: "https://polygonscan.com",
}

export enum PROVIDERS {
  PERA = "PERA",
  METAMASK = 'METAMASK',
  TRUST_WALLET = 'TRUST_WALLET',
  PHANTOM = "PHANTOM",
  WALLET_CONNECT = "WALLET_CONNECT",
  MOBILE = "MOBILE",
  COINBASE = "COINBASE",
  SOLFLARE = "SOLFLARE",
  BACKPACK = "BACKPACK",
}

export const PROVIDER_LOGO = {
  [PROVIDERS.METAMASK]: WALL_CONN,
  [PROVIDERS.PERA]: PERA,
  [PROVIDERS.PHANTOM]: PHA,
  [PROVIDERS.SOLFLARE]: SOL,
  [PROVIDERS.COINBASE]: COINBASE,
  [PROVIDERS.WALLET_CONNECT]: WALL_CONN,
  [PROVIDERS.MOBILE]: SOLANA,
  [PROVIDERS.BACKPACK]: BACKPACK,
};

export const PROVIDER_NAME = {
  [PROVIDERS.METAMASK]: "MetaMask",
  [PROVIDERS.PERA]: "Pera",
  [PROVIDERS.PHANTOM]: "Phantom",
  [PROVIDERS.SOLFLARE]: "Solflare",
  [PROVIDERS.COINBASE]: "Coinbase",
  [PROVIDERS.WALLET_CONNECT]: "WalletConnect",
  [PROVIDERS.MOBILE]: "Solana Mobile",
  [PROVIDERS.BACKPACK]: "Backpack",
};

type BlockcheinProvidersMap = Partial<{
  [K in BLOCKCHAINS]: PROVIDERS[];
}>;

export const BLOCKCHAIN_PROVIDERS: BlockcheinProvidersMap = {
  [BLOCKCHAINS.ETHEREUM]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.ALGORAND]: [PROVIDERS.PERA],
  [BLOCKCHAINS.POLYGON_MUMBAI]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.AVALANCHE_FUJI]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.AVALANCHE]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.BINANCE_SMART_CHAIN_TESTNET]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.BNB_SMART_CHAIN]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.ARBITRUM_ONE]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.OP_MAINNET]: [PROVIDERS.METAMASK],
  // [BLOCKCHAINS.OPTIMISM]: [PROVIDERS.WALLET_CONNECT_MODAL],
  [BLOCKCHAINS.BASE_GOERLI]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.BASE]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.SEPOLIA]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.BASE_SEPOLIA]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.SOLANA]: [PROVIDERS.PHANTOM, PROVIDERS.SOLFLARE, PROVIDERS.WALLET_CONNECT, PROVIDERS.MOBILE, PROVIDERS.BACKPACK],
  [BLOCKCHAINS.ARBITRUM_GOERLI]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.ARBITRUM_SEPOLIA]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.OPTIMISM_GOERLI]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.OP_SEPOLIA]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.POLYGON_AMOY]: [PROVIDERS.METAMASK],
  [BLOCKCHAINS.POLYGON]: [PROVIDERS.METAMASK],
  // [BLOCKCHAINS.APTOS]: [],
  // [BLOCKCHAINS.SUI]: [],
  // [BLOCKCHAINS.NEAR]: [],
};

// Not sure, maybe useful later
export enum LIBS {
  USEWALLET,
  WEB3MODAL,
  SOLANA,
}
export const LIBS_PROVIDERS = {
  [LIBS.USEWALLET]: [PROVIDERS.PERA],
  [LIBS.WEB3MODAL]: [PROVIDERS.METAMASK, PROVIDERS.TRUST_WALLET],
  [LIBS.SOLANA]: [PROVIDERS.PHANTOM, PROVIDERS.SOLFLARE, PROVIDERS.COINBASE, PROVIDERS.WALLET_CONNECT, PROVIDERS.MOBILE, PROVIDERS.BACKPACK],
};

export const isEvmChain = (chain: BLOCKCHAINS) => {
  return Object.keys(EVM_IDS_BLOCKCHAINS).includes(chain);
};

export function getBlockchainByChainId(chainId: number): BLOCKCHAINS | undefined {
  const chain = Object.entries(EVM_IDS_BLOCKCHAINS).find(([blockchainName, id]) => chainId === id)
  return chain && chain[0] as BLOCKCHAINS | undefined;
}

export function getWHChainIdByEVMChainId(evmChainId: number): number {
  const chainName = getBlockchainByChainId(evmChainId);
  const whChainId = getWhChainId(chainName);
  return whChainId;
}

export function getBlockchainByWhId(whId: string | number): BLOCKCHAINS | void {
  return WH_PROVIDER_CHAIN_NAME[Number(whId)];
}

export function getEvmChainId(chain: BLOCKCHAINS): number {
  return EVM_IDS_BLOCKCHAINS[chain]
}

export function getWhChainId(chain: BLOCKCHAINS): number {
  return WH_PROVIDER_CHAIN_ID[chain];
}

export const convertChainToSelectList = (chainList: Chain[] | IEvmChainInfo[]) => {
  return chainList.reduce((acc, tmc) => {
      const chain = ("name" in tmc && tmc?.name) ?? getBlockchainByWhId(tmc.whChainId) as BLOCKCHAINS;
      if (chain)
        acc.push({
          value: chain,
          img: CHAIN_LOGO[chain] || '',
        })
      return acc
    }, [] as {value: BLOCKCHAINS, img: string}[])
    .sort((a, b) => {
      if (a.value.toUpperCase() > b.value.toUpperCase()) return 1;
      if (a.value.toUpperCase() < b.value.toUpperCase()) return -1;
      return 0;
    });
}

export const getLogo = (chainId: number) => {
  if (chainId === 65537) return CIRCLE;
  return CHAIN_LOGO[WH_PROVIDER_CHAIN_NAME[chainId]];
}

export const getFullExplorerLink = (blockchain: BLOCKCHAINS, address: string, path: string) => {
  const query = (blockchain === BLOCKCHAINS.SOLANA && !isMainnet) ? "?cluster=devnet" : "";

  return `${BLOCKCHAIN_EXPLORER[blockchain]}/${path}/${address}${query}`
}

export const validateAddress = (chain: BLOCKCHAINS, pastedAddres: string) => {
  let isCorrectAddres = true;
  if (isEvmChain(chain)) {
    isCorrectAddres = isAddress(pastedAddres);
  } else if (chain === BLOCKCHAINS.ALGORAND) {
    isCorrectAddres = algosdk.isValidAddress(pastedAddres);
  } else if (chain === BLOCKCHAINS.SOLANA) {
    try {
      isCorrectAddres = PublicKey.isOnCurve(new PublicKey(pastedAddres));
    } catch (err) {
      isCorrectAddres = false;
    }
  }
  return isCorrectAddres;
}

export const getAddressChain = (pastedAddres: string): number | null => {
  let chainId = null;
  if (algosdk.isValidAddress(pastedAddres)) {
    chainId = 8;
  } else if (isAddress(pastedAddres)) {
    chainId = 5;
  } else {
    try {
      const isSolana = PublicKey.isOnCurve(new PublicKey(pastedAddres));
      if (isSolana) chainId = 1;
    } catch (err) {}
  }
  return chainId;
}